var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.308 20.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V6h-1V4.5H9v-.884h6V4.5h4.5V6h-1v12.692q0 .758-.525 1.283t-1.283.525zM17 6H7v12.692a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h9.385a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212zM9.404 17h1.5V8h-1.5zm3.692 0h1.5V8h-1.5z"
  })));
};
export default SvgTrash;